// src/features/continentStats/continentStatsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// hooks
import { doc, getDoc, setDoc, updateDoc, collection, getDocs } from 'firebase/firestore';
import { db } from 'src/auth/context/jwt/firebase';

const initialState = {
  value: null,
  loading: false,
  error: null,
};

export const continentStatsSlice = createSlice({
  name: 'continentStats',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContinentStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContinentStats.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getContinentStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    // .addCase(updateContinentStats.fulfilled, (state, action) => {
    //   // Update the local state with the new statistics
    //   const { continentCode, isWin } = action.payload;
    //   if (!state.value[continentCode]) {
    //     state.value[continentCode] = { totalGames: 0, totalWins: 0 };
    //   }

    //   state.value[continentCode].totalGames += 1;
    //   if (isWin) {
    //     state.value[continentCode].totalWins += 1;
    //   }
    // });
  },
});

// export const getContinentStats = createAsyncThunk(
//   'continentStats/getContinentStats',
//   async ({ uid }) => {
//     // Ensure you're referencing the correct path
//     const continentStatsRef = doc(db, 'users', uid, 'continentStats', 'data');
//     console.log('Fetching from:', continentStatsRef.path); // Log path for debugging
//     const docSnapshot = await getDoc(continentStatsRef);

//     if (docSnapshot.exists()) {
//       console.log('Continent Stats:', docSnapshot.data());
//       return docSnapshot.data();
//     }
//     console.log('No continent stats found at:', continentStatsRef.path);
//     return {}; // Return empty object if no data exists
//   }
// );

export const getContinentStats = createAsyncThunk(
  'continentStats/getAllContinentStats',
  async ({ uid }) => {
    // Reference to the continentStats subcollection for the user
    const continentStatsRef = collection(db, 'users', uid, 'continentStats');

    // Fetch all documents in the continentStats subcollection
    const querySnapshot = await getDocs(continentStatsRef);

    // Map the documents to return the data
    const continentStatsData = querySnapshot.docs.map((d) => ({
      continentCode: d.id, // Document ID is the continentCode
      ...d.data(),
    }));

    return continentStatsData;
  }
);

// export const getContinentStats = createAsyncThunk(
//   'continentStats/getContinentStats',
//   async ({ uid }) => {
//     const continentStatsRef = doc(db, 'users', uid, 'continentStats', 'data');
//     console.log('Fetching from:', continentStatsRef.path);
//     const docSnapshot = await getDoc(continentStatsRef);

//     console.log('----------------');
//     if (docSnapshot.exists()) {
//       console.log('Continent Stats:', docSnapshot.data());
//       return docSnapshot.data();
//     }
//     console.log('No document found at:', continentStatsRef.path);

//     return {}; // Return empty object if no data exists
//   }
// );

export const addGameToContinentStats = async ({ uid, continentCode, isWin }) => {
  const continentStatsRef = doc(db, 'users', uid, 'continentStats', continentCode);

  // Fetch the current stats or initialize if not found
  const docSnapshot = await getDoc(continentStatsRef);
  const data = docSnapshot.exists() ? docSnapshot.data() : { totalGames: 0, totalWins: 0 };

  // Update the stats
  data.totalGames += 1;
  if (isWin) {
    data.totalWins += 1;
  }

  // Write the updated data back to Firestore
  await setDoc(continentStatsRef, data);
};

export default continentStatsSlice.reducer;
